import type { GameMeta } from '@gmp/game-sdk';

export const pizzaHeistMeta = {
  id: 'pizza-heist',
  name: 'Pizza Heist',
  tagline: 'A raccoon crew, a backyard barbecue, and one very alert grillmaster.',
  description:
    'Co-op caper for 2–6 raccoons. Sneak through the backyard, grab pizza slices (or team up to haul the whole pizza) and drop them down the escape hole before lockdown. The grillmaster patrols with a vision cone, comes to check on noises and chases anyone he spots; caught raccoons sit in the time-out crate until a teammate springs them. Each raccoon picks one gloriously silly skill per round.',
  minPlayers: 2,
  maxPlayers: 6,
  estimatedMinutes: [4, 7],
  usesMedia: false,
  modes: [
    { id: 'heist', name: 'Heist', description: 'Three escalating rounds. Meet the pizza quota in most of them to pull off the heist; individual awards for deliveries, rescues and distractions.' },
  ],
  theme: { primary: '#ff6b35', secondary: '#9be564', background: '#16100c', ink: '#fff4ec' },
  readiness: 'beta',
  genre: 'Co-op caper',
  controls: 'touch-action',
  category: 'versus',
  instructions: [
    { icon: 'Pizza', title: 'Grab and deliver', body: 'Walk over a slice to pick it up, then drop it down the escape hole (bottom left). The whole pizza is heavy: carry it with a teammate to move faster.' },
    { icon: 'Eye', title: 'Stay out of the cone', body: 'The grillmaster sees what is in his yellow cone. A “?” over you means he is noticing; “!” means run. Bushes hide you while you sneak slowly.' },
    { icon: 'Package', title: 'Spring the crate', body: 'Caught raccoons sit in the time-out crate by the patio. Stand next to it with a teammate inside to break them out.' },
    { icon: 'Sparkles', title: 'One silly skill', body: 'Pick a skill each round: Rattle a can, Roll in a Bush, Dash, Bait Hot Dog or Rescue Grab. Each has a cooldown and a catch.' },
    { icon: 'Siren', title: 'Beat the lockdown', body: 'Meet the pizza quota before the timer runs out. Later rounds add the whole pizza, sprinklers and a dog. Points for every slice, rescue and distraction.' },
  ],
} satisfies GameMeta;
